<template>
  <div class="header-contain">
    <div class="header-info">
      <div class="layout flex-between">
        <Logo class="header-logo" @click.native="load" />
        <div class="header-login" v-if="oidcUser">
          <i class="el-icon-s-custom"/>{{ userName ? userName : oidcUser.name }}，您好!&nbsp;
          <a href="javascript:;" @click="signOutOidc">退出登录</a>
        </div>
      </div>
    </div>
    <div class="header-nav">
      <ul class="layout">
        <li @click="$route.name=='apps'?load():''">
          <router-link to="/workflow/index" tag="a" active-class="active" >应用中心</router-link>
        </li>
        <li @click="$route.name=='todo'?load():''">
          <router-link to="/workflow/todo" tag="a"
                       :class="isPage('todo') ||isPage('doing') ||isPage('done') ||isPage('flow_cc')?'active':''">
            <el-badge :value="todos_num? todos_num : 0" class="item">我的事项</el-badge>
          </router-link>
        </li>
        <li>
          <a href="https://service.scau.edu.cn/sign-center/manage/home" target="_blank">我的证照</a>
        </li>
        <li>
          <a href="https://service.scau.edu.cn/hnnyqjzx_data" target="_blank">我的数据</a>
        </li>
        <li>
          <router-link to="/workflow/guide" tag="a" active-class="active">流程攻略</router-link>
        </li>
        <li>
          <a href="https://service.scau.edu.cn/scau_cms_yx/portal/letter_sy.jsp" target="_blank">校长信箱</a>
        </li>
        <li>
          <a href=" https://service.scau.edu.cn/yy-sys/pc/home" target="_blank">场地预约</a>
        </li>
        <li>
          <router-link to="/workflow/infos" tag="a" active-class="active">通知公告</router-link>
        </li>
      </ul>
    </div>
    <div class="user-tips" v-if="isPage('todo') ||isPage('doing') ||isPage('done') ||isPage('flow_cc')">
      <ul class="layout">
        <li>
          <router-link to="/workflow/todo" tag="a" active-class="active">待办</router-link>
        </li>
        <li>
          <router-link to="/workflow/doing" tag="a" active-class="active">进行中</router-link>
        </li>
        <li>
          <router-link to="/workflow/done" tag="a" active-class="active">已完成</router-link>
        </li>
        <li>
          <router-link to="/workflow/flow_cc" tag="a" active-class="active">抄送</router-link>
        </li>
      </ul>
    </div>
    <div class="vertical_menu" v-if="$route.path == '/workflow/index'">
      <dl class="vertical_nav" style="border-radius: 10px 10px 0px 0px;">
        <a @click="pushUrl('https://xxgk.scau.edu.cn/')">
          <dt><img src="@/assets/images/xxgk.png" alt=""></dt>
          <dd>信息公开</dd>
        </a>
      </dl>
      <!--      <dl class="vertical_nav">-->
      <!--        <a @click="pushUrl('https://service.scau.edu.cn/portal/taskcenter-v4/opinion_list.jsp')">-->
      <!--          <dt><img src="@/assets/images/yjzj.png" alt=""></dt>-->
      <!--          <dd>意见征集</dd>-->
      <!--        </a>-->
      <!--      </dl>-->
      <dl class="vertical_nav">
        <a @click="pushUrl('http://service.scau.edu.cn/infoplus/form/XiTongShiYongZiXun/start')">
          <dt><img src="@/assets/images/zxjy.png" alt=""></dt>
          <dd>服务咨询</dd>
        </a>
      </dl>
      <!--      <dl class="vertical_nav">-->
      <!--        <a @click="pushUrl('https://service.scau.edu.cn/portal/taskcenter-v4/about_us.jsp')">-->
      <!--          <dt><img src="@/assets/images/gywm.png" alt=""></dt>-->
      <!--          <dd>关于我们</dd>-->
      <!--        </a>-->
      <!--      </dl>-->
      <dl class="vertical_nav" style="border-radius: 0px 0px 10px 10px; border:0;">
        <a @click="pushTop">
          <dt><img src="@/assets/images/fhdb.png" alt=""></dt>
          <dd>返回顶部</dd>
        </a>
      </dl>
    </div>
  </div>
</template>
<script>
import Logo from "@/components/todoCenter/logo.vue"
import {mapGetters, mapActions} from "vuex";

export default {
  name: "myHeader",
  inject: ["isPage", "routeName"],
  components: {Logo},
  data() {
    return {
      userName: "",
      account: "",
      pageWords: {
        todo: "待办",
        doing: "进行中",
        done: "已完成",
        flow_cc: "抄送"
      }
    }
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcUser"]),
    todos_num() {
      return this.$store.getters.getDataSource['todo'].length;
    },
    pageName() {
      return this.routeName();
    }
  },
  methods: {
    ...mapActions("oidcStore", ["signOutOidc"]),
    pushUrl(val) {
      window.open(val);
    },
    pushTop() {
      document.body.scrollIntoView({behavior: "smooth"});
    },
    load(){
     if(this.$route.name!=='apps'&&this.$route.name!=='todo'){
       this.$router.push({name:'apps',path:'/workflow/index'})
     }else{
       location.reload()
     }
    }
  },
};
</script>
<style>
.visitNum {
  position: absolute;
  right: 20px;
  top: 0px;
  height: 40px;
  line-height: 40px;
  white-space: nowrap;
  margin-bottom: 0px;
}

.el-badge__content.is-fixed {
  top: 9px !important;
  border: none!important;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/myHeader.vue